// Farm View fields table columns. Crop water availability is the basic column
// and always visible; the Advanced mode columns follow it in this order.
// TableHeader and FieldRow (IrrigationSystemMonitoring.jsx) both render the
// advanced columns from ADVANCED_COLUMNS, so header and row cells can't drift
// apart.
const ALWAYS_VISIBLE_COLUMN = 'crop_water_availability';

const ADVANCED_COLUMNS = [
  'irrigation_activity',
  'weekly_performance',
  'water_potential',
  'weekly_recommendation',
];

const FARM_TABLE_COLUMNS = [ALWAYS_VISIBLE_COLUMN, ...ADVANCED_COLUMNS];

module.exports = {
  ALWAYS_VISIBLE_COLUMN,
  ADVANCED_COLUMNS,
  FARM_TABLE_COLUMNS,
};
